
import {get_now_time} from '../../../utils/base'
export default {    
    transdateList(state) {
        return state.transdateList
    },
    nowTime(state) {
        return state.nowTime
    },
    endTime({nowTimeSection,baseConf,tomorrow,todayIsTransdate}) {
        let endTime = baseConf.endTime
        let nowTime = get_now_time()
        if(todayIsTransdate == 1){
            if(nowTimeSection == 2){
                endTime.years = tomorrow.years
                endTime.months = tomorrow.months
                endTime.days = tomorrow.days
            } else {
                endTime.years = nowTime.years
                endTime.months = nowTime.months
                endTime.days = nowTime.days
            }
        }else{
            endTime.years = tomorrow.years
            endTime.months = tomorrow.months
            endTime.days = tomorrow.days
        }
        endTime.times = (new Date(endTime.years,endTime.months- 1,endTime.days,endTime.hours,endTime.minutes,endTime.seconds)).getTime()
        return endTime
    },
    tomorrow(state) {
        return state.tomorrow
    },
    shangzheng(state) {
        return state.shangzheng
    },
    todayIsTransdate(state) {
        return state.todayIsTransdate
    },
    nowTimeSection(state) {
        return state.nowTimeSection
    },
    myBetInfo(state) {
        return state.myBetInfo
    },
    nextBetInfo(state) {
        return state.nextBetInfo
    },
    hasPut(state) {
        return state.hasPut
    },
    transDate(state) {
        return state.transDate
    },
    summary(state) {
        return state.summary
    },
    detailTimeStatus(state) {
        return state.detailTimeStatus
    },
    myBetDetail(state) {
        return state.myBetDetail
    },
}